/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { CreateDefinitionDtoValueType } from './CreateDefinitionDtoValueType';
import {
    CreateDefinitionDtoValueTypeFromJSON,
    CreateDefinitionDtoValueTypeFromJSONTyped,
    CreateDefinitionDtoValueTypeToJSON,
} from './CreateDefinitionDtoValueType';
import type { CreateDiscreteNumericListDtoGeometry } from './CreateDiscreteNumericListDtoGeometry';
import {
    CreateDiscreteNumericListDtoGeometryFromJSON,
    CreateDiscreteNumericListDtoGeometryFromJSONTyped,
    CreateDiscreteNumericListDtoGeometryToJSON,
} from './CreateDiscreteNumericListDtoGeometry';
import type { EntityOrigin } from './EntityOrigin';
import {
    EntityOriginFromJSON,
    EntityOriginFromJSONTyped,
    EntityOriginToJSON,
} from './EntityOrigin';

/**
 * 
 * @export
 * @interface NumericListDto
 */
export interface NumericListDto {
    /**
     * 
     * @type {string}
     * @memberof NumericListDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof NumericListDto
     */
    dataTypeId?: string;
    /**
     * 
     * @type {string}
     * @memberof NumericListDto
     */
    name?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof NumericListDto
     */
    isRequired?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NumericListDto
     */
    isReadonly?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NumericListDto
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof NumericListDto
     */
    iuid?: string | null;
    /**
     * 
     * @type {EntityOrigin}
     * @memberof NumericListDto
     */
    origin?: EntityOrigin;
    /**
     * 
     * @type {string}
     * @memberof NumericListDto
     */
    numericId?: string;
    /**
     * 
     * @type {number}
     * @memberof NumericListDto
     */
    max?: number | null;
    /**
     * 
     * @type {number}
     * @memberof NumericListDto
     */
    min?: number | null;
    /**
     * 
     * @type {string}
     * @memberof NumericListDto
     */
    unitAbbreviation?: string | null;
    /**
     * 
     * @type {CreateDefinitionDtoValueType}
     * @memberof NumericListDto
     */
    valueType?: CreateDefinitionDtoValueType | null;
    /**
     * 
     * @type {number}
     * @memberof NumericListDto
     */
    decimalPlaces?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof NumericListDto
     */
    values?: Array<number> | null;
    /**
     * 
     * @type {CreateDiscreteNumericListDtoGeometry}
     * @memberof NumericListDto
     */
    geometry?: CreateDiscreteNumericListDtoGeometry | null;
    /**
     * 
     * @type {string}
     * @memberof NumericListDto
     */
    $type?: NumericListDtoTypeEnum;
}


/**
 * @export
 */
export const NumericListDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoNumericDtoNumericListDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.NumericListDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type NumericListDtoTypeEnum = typeof NumericListDtoTypeEnum[keyof typeof NumericListDtoTypeEnum];


/**
 * Check if a given object implements the NumericListDto interface.
 */
export function instanceOfNumericListDto(value?: unknown): value is NumericListDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(NumericListDtoTypeEnum)[0];
}

export function NumericListDtoFromJSON(json: any): NumericListDto {
    return NumericListDtoFromJSONTyped(json, false);
}

export function NumericListDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NumericListDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'dataTypeId': !exists(json, 'dataTypeId') ? undefined : json['dataTypeId'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'isRequired': !exists(json, 'isRequired') ? undefined : json['isRequired'],
        'isReadonly': !exists(json, 'isReadonly') ? undefined : json['isReadonly'],
        'isEnabled': !exists(json, 'isEnabled') ? undefined : json['isEnabled'],
        'iuid': !exists(json, 'iuid') ? undefined : json['iuid'],
        'origin': !exists(json, 'origin') ? undefined : EntityOriginFromJSON(json['origin']),
        'numericId': !exists(json, 'numericId') ? undefined : json['numericId'],
        'max': !exists(json, 'max') ? undefined : json['max'],
        'min': !exists(json, 'min') ? undefined : json['min'],
        'unitAbbreviation': !exists(json, 'unitAbbreviation') ? undefined : json['unitAbbreviation'],
        'valueType': !exists(json, 'valueType') ? undefined : CreateDefinitionDtoValueTypeFromJSON(json['valueType']),
        'decimalPlaces': !exists(json, 'decimalPlaces') ? undefined : json['decimalPlaces'],
        'values': !exists(json, 'values') ? undefined : json['values'],
        'geometry': !exists(json, 'geometry') ? undefined : CreateDiscreteNumericListDtoGeometryFromJSON(json['geometry']),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function NumericListDtoToJSON(value?: NumericListDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value.id,
        'dataTypeId': value.dataTypeId,
        'name': value.name,
        'isRequired': value.isRequired,
        'isReadonly': value.isReadonly,
        'isEnabled': value.isEnabled,
        'iuid': value.iuid,
        'origin': EntityOriginToJSON(value.origin),
        'numericId': value.numericId,
        'max': value.max,
        'min': value.min,
        'unitAbbreviation': value.unitAbbreviation,
        'valueType': CreateDefinitionDtoValueTypeToJSON(value.valueType),
        'decimalPlaces': value.decimalPlaces,
        'values': value.values,
        'geometry': CreateDiscreteNumericListDtoGeometryToJSON(value.geometry),
        '$type': value.$type,
    });
}

